export const LEVEL_COLORS = ['#f9f9f9', '#f1f8e9', '#e3f2fd', '#fff8e1', '#fce4ec', '#ede7f6'];

export const MAX_JSON_FILE_SIZE_BYTES = 100 * 1024 * 1024;
export const HUD_JSON_TREE_ROW_HEIGHT = 48;
export const HUD_JSON_TREE_ADD_ROW_HEIGHT = 250;
